<template>
  <div class="teamWidget">
    <v-card>
      <v-card-title class="pb-0">
        <team-name :team="team" class="teamName" />
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0 ma-0">
          <v-row v-if="team.teamInvitation" align="center" no-gutters class="mb-3">
              <p class="mb-0"><v-icon class="mr-2" color="primary" small>mdi-information</v-icon>
                {{ $t('teamWidget.pending-invite') }}</p>
              <v-btn class="primary ml-3" small @click="acceptTeamInvitation">{{ $t('teamWidget.accept') }}</v-btn>
          </v-row>
          <v-row
            v-for="teamPlayer in team.teamPlayers"
            v-bind:key="teamPlayer.player.uid"
            no-gutters
          >
            <v-col cols="12" class="pa-1 pl-2">
              <user-widget
                :user="teamPlayer.player"
                :game="game"
                :showDefaultActions="['details']"
                :actions="teamUserActions(teamPlayer)"
                :renderSocialiteIcons="false"
              >
                <span
                  v-if="teamPlayer.memberSince === null"
                  class="pendingInvite"
                  >&nbsp;({{$t('teamWidget.pending-invite')}})</span
                >
              </user-widget>
            </v-col>
          </v-row>
          <slot></slot>
        </v-container>
      </v-card-text>
    </v-card>
    <drop-player-dialog
      v-if="dropPlayer"
      :player="dropPlayer"
      :closeAction="closeDropPlayerDialog"
      :confirmAction="confirmedDropPlayer"
    />
  </div>
</template>

<script>
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store";
import UserWidget from "@/widgets/UserWidget.vue";
import TeamName from "./TeamName.vue";
import DropPlayerDialog from './tools/DropPlayerDialog.vue';
import { EVENT_REFRESH_DATA } from '../plugins/eventbus'

export default {
  name: "TeamWidget",
  components: {
    UserWidget,
    TeamName,
    DropPlayerDialog,
  },
  props: {
    team: {
      type: Object,
      required: true,
    },
    game: {
      type: Object,
      required: false,
    },
  },
  data: function () {
    return {
      loading: false,
      teams: undefined,
      createTeamDialogVisible: false,
      dropPlayer: undefined,
    };
  },
  computed: {},
  watch: {
    game: function (val, oldVal) {
      if (val.uid != oldVal.uid) {
        console.log("game changed", val, oldVal);
      }
    },
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    teamUserActions(teamPlayer) {
      let player = teamPlayer.player;
      let ret = {};
      let me = this;
      ret.dropPlayer = {
        icon: "mdi-karate",
        classes: "error",
        label: this.$t("common.drop-player"),
        action: function (user) {
          me.dropPlayer = user;
          console.log(player)
        },
      };
      return ret;
    },
    acceptTeamInvitation(){
      this.$api.acceptTeamInvitation(this.game.uid, this.team.uid)
      .then(() => {
        this.loading = false
        this.$eventBus.$emit(EVENT_REFRESH_DATA)
      })
      .catch(err => {
        this.loading = false
        this.$common.onError(err);
      })
    },
    closeDropPlayerDialog() {
      this.dropPlayer = undefined;
    },
    confirmedDropPlayer(player) {
      console.log('confirmedDropPlayer', player)
      this.dropUserFromGameInstanceTeam(this.team.uid, player)
    },
    dropUserFromGameInstanceTeam(teamUid, player) {
      this.loading = true;
      this.$api
        .dropUserFromGameInstanceTeam(
          this.game.uid,
          teamUid,
          player.uid
        )
        .then(() => {
          this.loading = false;
          this.$eventBus.$emit(EVENT_REFRESH_DATA)
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: this.$t(
              "common.player-dropped-successfully",
              { name: player.name }
            ),
            type: "success",
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$common.onError(error);
        });
    }
  },
};
</script>
<style scoped>
.teamName {
  font-weight: bold;
}
.pendingInvite {
  font-style: italic;
}
</style>
